import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { MARK_AS_READ } from "src/api-setup/api-endpoints";

export const markAsRead = async (cookiesData, dispatch, unreadMessages) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: String(cookiesData?.out_user_id),
      in_tenant_id: cookiesData?.out_tenant_id || "",
      in_message_mstr_key: unreadMessages,
    };

    const response = await POSTAPI(false, MARK_AS_READ, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response.data.row_result) {
      return response?.data;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
